import "admin-lte";
import "@fortawesome/fontawesome-free/js/all";
import "@hotwired/turbo-rails";
import "../controllers";
import initialSelectbox from "../javascripts/selectbox";
import initialHeavyMachineGroupSelectbox from "../javascripts/heavyMachineGroupSelectbox";
import initialDropdown from "../javascripts/dropdown";
import initialTab from "../javascripts/tab";
import initialFlatpickr from "../javascripts/flatpickr";
import initialColorSelector from "../javascripts/colorSelector";
import initialInspection from "../javascripts/inspection";
import attachUserDynamicMap from "../javascripts/attachments/dynamicMap";
import attachHeavyMachineStaticMap from "../javascripts/attachments/heavyMachineStaticMap";
import attachSiteStaticMap from "../javascripts/attachments/siteStaticMap";
import attachSiteDynamicMap from "../javascripts/attachments/siteDynamicMap";
import attachResourceTimeline from "../javascripts/attachments/resourceTimeline";
import attachCheckListForm from "../javascripts/attachments/checkListForm";
import initialCollapseCard from "../javascripts/collapseCard";
import initialInputFilter from "../javascripts/inputFilter";
import initialInspectedRangeSelect from "../javascripts/inspectedRangeSelect";
import { initializeAnnouncementListeners } from "../javascripts/announcement";

initialSelectbox();
initialHeavyMachineGroupSelectbox();
initialDropdown();
initialTab();
initialFlatpickr();
initialColorSelector();
initialInspection();
initialCollapseCard();
initialInputFilter();
initialInspectedRangeSelect();
initializeAnnouncementListeners();

// attach react component
["turbo:load"].forEach((event) =>
  document.addEventListener(event, () => {
    attachUserDynamicMap();
    attachHeavyMachineStaticMap();
    attachSiteStaticMap();
    attachSiteDynamicMap();
    attachResourceTimeline();
    attachCheckListForm();
  }),
);

["turbo:render"].forEach((event) =>
  document.addEventListener(event, () => {
    attachSiteDynamicMap();
  }),
);
